import React from 'react';
import { ImageProps } from '.';

const SvgCreditCardVisa = ({ size = 48, ...props }: ImageProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={(size && Math.floor(size / 1.263157894736842)) || 38}
      fill='none'
      viewBox='0 0 48 38'
      {...props}
    >
      <rect width={47} height={37} x={0.5} y={0.5} fill='#fff' stroke='#E2E5E6' rx={7.5} />
      <path
        fill='#00579F'
        d='M20.69 24.313h-2.747l1.718-10.62h2.746l-1.718 10.62ZM30.644 13.952a6.769 6.769 0 0 0-2.463-.452c-2.712 0-4.621 1.446-4.633 3.514-.023 1.525 1.367 2.372 2.407 2.88 1.062.52 1.423.86 1.423 1.323-.01.711-.858 1.04-1.649 1.04-1.096 0-1.684-.17-2.576-.566l-.362-.17-.384 2.385c.644.293 1.83.553 3.062.565 2.882 0 4.757-1.424 4.78-3.627.01-1.209-.723-2.135-2.305-2.892-.96-.486-1.549-.814-1.549-1.311.011-.452.497-.915 1.582-.915a4.664 4.664 0 0 1 2.045.407l.249.112.373-2.293ZM34.294 20.55l1.096-2.971c-.011.023.226-.622.361-1.017l.192.915s.52 2.542.633 3.073h-2.282Zm3.39-6.857h-2.125c-.655 0-1.152.191-1.435.88l-4.079 9.74h2.881l.577-1.594h3.526c.078.373.327 1.593.327 1.593H39.9l-2.216-10.62ZM15.65 13.693l-2.69 7.241-.293-1.468c-.498-1.695-2.057-3.536-3.797-4.452l2.463 9.287h2.904l4.316-10.608H15.65Z'
      />
      <path
        fill='#FAA61A'
        d='M10.463 13.693H6.045L6 13.907c3.446.881 5.729 3.006 6.667 5.56l-.96-4.882c-.159-.678-.645-.87-1.244-.893Z'
      />
    </svg>
  );
};

export default SvgCreditCardVisa;
